module.exports = __webpack_public_path__ + "img/3_r.06ea78c1.jpg";